import { subscribeKey as subKey } from 'valtio/vanilla/utils';
import { proxy } from 'valtio/vanilla';
import { CoreHelperUtil } from '../utils/CoreHelperUtil.js';
// -- State --------------------------------------------- //
const state = proxy({
    message: '',
    variant: 'success',
    open: false
});
// -- Controller ---------------------------------------- //
export const SnackController = {
    state,
    subscribeKey(key, callback) {
        return subKey(state, key, callback);
    },
    showLoading(message) {
        this._showMessage(message, 'loading');
    },
    showSuccess(message) {
        this._showMessage(message, 'success');
    },
    showError(message) {
        const errorMessage = CoreHelperUtil.parseError(message);
        this._showMessage(errorMessage, 'error');
    },
    hide() {
        state.open = false;
    },
    _showMessage(message, variant) {
        if (state.open) {
            state.open = false;
            setTimeout(() => {
                state.message = message;
                state.variant = variant;
                state.open = true;
            }, 150);
        }
        else {
            state.message = message;
            state.variant = variant;
            state.open = true;
        }
    }
};
//# sourceMappingURL=SnackController.js.map